const PROXY_ROOT = '/proxy';

export const GEO_API_PROXY_ENDPOINT = `${PROXY_ROOT}/geo-api`;
export const GEOPL_API_PROXY_ENDPOINT = `${PROXY_ROOT}/geopl-api`;
export const GEORISQUES_API_PROXY_ENDPOINT = `${PROXY_ROOT}/georisques-api`;
export const GEORISQUES_WMS_PROXY_ENDPOINT = `${PROXY_ROOT}/georisques-wms`;
export const PISTE_API_PROXY_ENDPOINT = `${PROXY_ROOT}/piste-api`;
export const BRGM_WMS_PROXY_ENDPOINT = `${PROXY_ROOT}/brgm-wms`;
